module.exports = __webpack_public_path__ + "img/sj.902a33d0.svg";